<template>
  <div class="info-message">
    <div class="info-message__content">
      <span
        v-if="icon"
        :class="['icon', icon]"
      />

      <span class="info-message__text">
        {{ message }}
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InfoBanner',

    props: {
      message: {
        type: String,
        required: true
      },

      icon: {
        type: String,
        default: null
      }
    }
  };
</script>
